import React, { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Socket } from "socket.io-client";
import { selectUser } from "../../core/auth/authSlice";
import socketService from "../../core/socket/socket.service";
import { User } from "../../shared/models";

const WebSocketContext = createContext<Socket | undefined>(undefined);

export const WebSocketProvider = ({ children }: React.PropsWithChildren) => {
  const { actorId } = useSelector(selectUser) as User;
  const [socket, setSocket] = useState<Socket | undefined>(undefined);

  useEffect(() => {
    if (!actorId) return;

    let instance = socketService.getSocket(actorId);
    if (!instance) {
      instance = socketService.connect(actorId, null);
    }
    setSocket(instance);
  }, [actorId]);

  return (
    <WebSocketContext.Provider value={socket}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
